/**
 * BroadcastStats — прогресс sent/failed/skipped
 * Дата: 26.02.2026 — PLAN Manual Broadcasts
 */
interface BroadcastStatsProps {
  total: number;
  sent: number;
  failed: number;
  skipped: number;
  compact?: boolean;
}

export function BroadcastStats({ total, sent, failed, skipped, compact }: BroadcastStatsProps) {
  if (total === 0) return null;

  const sentW = total > 0 ? (sent / total) * 100 : 0;
  const failedW = total > 0 ? (failed / total) * 100 : 0;
  const skippedW = total > 0 ? (skipped / total) * 100 : 0;

  if (compact) {
    return (
      <div className="flex items-center gap-2 text-xs text-neutral-600">
        <span className="text-green-600 font-medium">{sent}</span>
        <span>/</span>
        <span className="text-red-600">{failed}</span>
        <span>/</span>
        <span className="text-amber-600">{skipped}</span>
        <span>из {total}</span>
      </div>
    );
  }

  return (
    <div className="space-y-1" data-testid="broadcast-stats">
      <div className="flex h-2 rounded-full overflow-hidden bg-neutral-200">
        {sentW > 0 && <div className="bg-green-500" style={{ width: `${sentW}%` }} title={`Отправлено: ${sent}`} />}
        {failedW > 0 && <div className="bg-red-500" style={{ width: `${failedW}%` }} title={`Ошибки: ${failed}`} />}
        {skippedW > 0 && (
          <div className="bg-amber-500" style={{ width: `${skippedW}%` }} title={`Пропущено: ${skipped}`} />
        )}
      </div>
      <div className="flex gap-3 text-xs">
        <span className="text-green-600">✓ {sent}</span>
        <span className="text-red-600">✗ {failed}</span>
        <span className="text-amber-600">⊙ {skipped}</span>
        <span className="text-neutral-500">из {total}</span>
      </div>
    </div>
  );
}
